import React, {FC, useEffect, useState} from 'react';
import {locationValues} from '@geomatico/maplibre-cog-protocol';
import {MapRef} from 'react-map-gl/maplibre';

const DefaultFormatter: FC<{value: number}> = ({value}) => <>{value}</>;

export interface ValueTooltipProps {
  mapRef: React.RefObject<MapRef | null>,
  url: string,
  formatter?: FC<{value: number}>,
  decimals?: number,
  band?: number,
  onPixel?: (result: Array<number>) => void
}

const ValueTooltip: FC<ValueTooltipProps> = ({mapRef, url, formatter: Formatter = DefaultFormatter, band = 0, onPixel}) => {
  const [style, setStyle] = useState<React.CSSProperties>({
    display: 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    background: '#2d2d2d',
    border: '1px solid #bbbbbb',
    color: '#bbbbbb',
    padding: 6,
    borderRadius: 5,
    fontFamily: 'monospace',
    fontSize: 18
  });
  const [value, setValue] = useState<number>();

  useEffect(() => {
    const map = mapRef.current;
    if (map) {
      map.on('drag', () =>
        setStyle(prevStyle => ({
          ...prevStyle,
          display: 'none'
        }))
      );

      map.on('mousemove', (e) => {
        const {lngLat: {lat: latitude, lng: longitude}, point: {x, y}} = e;
        const zoom = map.getZoom();

        setStyle(prevStyle => ({
          ...prevStyle,
          left: x + 10,
          top: y + 20
        }));

        locationValues(url, {latitude, longitude}, zoom)
          .then(result => {
            if (onPixel) {
              onPixel(result);
            }
            const value = result[band];
            if (isNaN(value)) {
              map.getCanvas().style.cursor = '';
              setStyle(prevStyle => ({
                ...prevStyle,
                display: 'none'
              }));
            } else {
              map.getCanvas().style.cursor = 'default';
              setStyle(prevStyle => ({
                ...prevStyle,
                display: 'block'
              }));
              setValue(value);
            }
          });
      });
    }
  }, [mapRef.current, band]);

  return <div style={style}>
    {value !== undefined ?
      <Formatter value={value}/>
      : null
    }
  </div>;
};

export default ValueTooltip;
